module.exports = __webpack_public_path__ + "img/person.d83aaae3.svg";